module.exports = {
      id: "close-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }